import { useMemo } from 'react';

import { DocumentType } from '@/types/schema';

import { getEligibleDocumentTypes } from '../ManageDocumentAmendments/utils/ManageDocumentAmendments.utils';

/**
 * Hook to determine if a document supports multi-document summaries
 * based on its document type eligibility.
 *
 * @param document - Document object containing at least the type field
 * @returns boolean indicating if the document supports multi-document summaries
 */
export function useSupportsMultiDocSummary(
  documentType: DocumentType | null
): boolean {
  return useMemo(() => {
    if (!documentType) {
      return false;
    }

    const eligibleDocumentTypes = getEligibleDocumentTypes();
    return eligibleDocumentTypes.includes(documentType);
  }, [documentType]);
}
